import { AxiosInstance } from "axios";
import {
  apiHost,
  createOne,
  CrudApi,
  deleteOne,
  queryList,
  queryOne,
  toUrlParamsForQuery,
  updateOne
} from "../../shared/technical/rest/restApi";
import { Company } from "./Company";
import { handleErrorResponse, handleSuccessResponse } from "../../shared/technical/rest/errorHandling";
import { fullPageable } from "../../shared/technical/rest/pageable";

export const companyCrudApi: CrudApi<Company, Company> = {
  queryList: getAllCompanies,
  queryOne: getCompany,
  createOne: createCompany,
  updateOne: updateCompany,
  deleteOne: deleteCompany
}

export function getAllCompanies(axios: AxiosInstance, params?: string): Promise<Company[]> {
  const pageParams = toUrlParamsForQuery(fullPageable());
  const allParams = params ? `${pageParams}&${params}` : pageParams;
  return queryList(axios, 'companies', allParams)
}

export function getCompany(axios: AxiosInstance, companyId: string | number): Promise<Company> {
  return queryOne(axios, 'companies', companyId)
}

export function createCompany(axios: AxiosInstance, company: Company): Promise<Company> {
  return createOne(axios, 'companies', company)
}

export function updateCompany(axios: AxiosInstance, company: Company): Promise<Company> {
  return updateOne(axios, 'companies', company)
}

export function deleteCompany(axios: AxiosInstance, companyId: string | number): Promise<void> {
  return deleteOne(axios, 'companies', companyId)
}

export function syncCompanies(axios: AxiosInstance): Promise<void> {
  const baseUri = apiHost + '/companies/company-sync';
  return axios.post(baseUri).then(handleSuccessResponse, handleErrorResponse);
}
